import { usePartnersOperations } from './usePartnersOperations';

export { usePartnersOperations };
